import { BaseButton } from '@/components/common/base-button';
import PlaceHolder from '@/components/icons/shop/PlaceHolder';
import type { PoiContent } from '@/services/dto';
import { useConfigStore } from '@/stores';
import clsx from 'clsx';
import { useMemo, useState } from 'react';
import styles from './styles.module.scss';

type PoiImageProps = {
    src?: string;
    alt: string;
};

const PoiImage = ({ src, alt }: PoiImageProps) => {
    const [hasError, setHasError] = useState(false);

    if (!src || hasError) {
        return <PlaceHolder />;
    }

    return <img src={src} alt={alt} onError={() => setHasError(true)} />;
};

type Props = {
    poiList?: PoiContent[];
    onSelectPoi?: (poi: PoiContent) => void;
    selectedPoiId?: string;
};
export const PoiListCarousel = ({ poiList, onSelectPoi, selectedPoiId }: Props) => {
    const {
        config: {
            ui: { language },
        },
    } = useConfigStore();
    const isShowPoiList = useMemo(() => {
        if (!Array.isArray(poiList) || !poiList?.length) {
            return false;
        }
        return true;
    }, [poiList]);

    if (!isShowPoiList) {
        return null;
    }

    return (
        <div className={clsx(styles['poi-list-carousel'], 'scrollbar-hide')}>
            {Array.isArray(poiList) &&
                poiList?.map((poi, index) => {
                    const imageUrl = poi?.contents?.shopTmrkImgUrlApp?.[language] || poi?.contents?.shopTmrkImgUrlApp?.['ko'];
                    const poiName = poi?.name?.[language] || poi?.name?.['ko'] || '';

                    return (
                        <BaseButton
                            data-modal-region={index === 0}
                            tabIndex={10}
                            data-interactive
                            key={poi?.id}
                            onClick={() => onSelectPoi?.(poi)}
                            className={clsx(styles['poi-list-carousel__item'], {
                                [styles['poi-list-carousel__item--selected']]: selectedPoiId === poi?.id,
                            })}
                        >
                            <div className={styles['poi-list-carousel__image']}>
                                <PoiImage key={imageUrl} src={imageUrl} alt={poiName} />
                            </div>
                            <div
                                className={clsx(styles['poi-list-carousel__name'], {
                                    [styles['poi-list-carousel__name--selected']]: selectedPoiId === poi?.id,
                                })}
                            >
                                {poiName}
                            </div>
                            {selectedPoiId !== poi?.id && <div className={clsx(styles['poi-list-carousel__mask'])}></div>}
                        </BaseButton>
                    );
                })}
        </div>
    );
};
